import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  ContactRelationshipsService,
  ContactsService,
  InsurancesService,
} from 'src/app/core/lists';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { GeneralAutocompleteComponent } from '../../../layout/general-autocomplete/general-autocomplete.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-select-entities-dialog',
  templateUrl: './select-entities-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectEntitiesDialogComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  entitySelectForm: FormGroup;
  viewLoading = true;
  loadingAfterSubmit = false;
  entityAutocompleteCall;
  filterFn;
  @ViewChild('entityAutocomplete') entityAutocomplete: GeneralAutocompleteComponent;
  entityTypeBS = new BehaviorSubject('');
  entitySearchFields = [];

  constructor(
    private contactsService: ContactsService,
    public dialogRef: MatDialogRef<SelectEntitiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private contactRelationshipsService: ContactRelationshipsService,
    private cdr: ChangeDetectorRef,
    public stringUtils: StringUtilsService,
    private insuranceService: InsurancesService,
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.entityTypeBS.subscribe((type) => {
        this.entitySearchFields = this.stringUtils.getEntitySearchFields(type);

        switch (type) {
          case 'CONTACT':
            this.entityAutocompleteCall = this.contactsService.searchContactByField.bind(
              this.contactsService,
            );
            break;

          case 'INSURANCE':
            this.entityAutocompleteCall = this.insuranceService.insuranceAutocomplete.bind(
              this.insuranceService,
            );
            break;

          default:
            this.entityAutocompleteCall = this.contactRelationshipsService.searchEntityByField.bind(
              this.contactRelationshipsService,
              type,
            );
        }
      }),
    );

    this.filterFn = this.data.filterFn;
    this.createForm();
    this.viewLoading = false;
    this.entityTypeBS.next(this.entitySelectForm?.get('entityType')?.value);
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  createForm() {
    this.entitySelectForm = this.fb.group({
      entityType: [this.data.source === 'COMMUNICATION-RELATED' ? 'PATIENT' : 'DOCTOR'],
      entities: [this.data.entities ? this.data.entities : []],
    });
  }

  onEntityChange(val) {
    const entities = val.map((item) => {
      if (item && item.id) {
        const entity_id = +item.id;

        return {
          entity_id,
          dob: item.dob,
          first_name: item.first_name ? item.first_name : item.name,
          last_name: item.last_name,
          is_active: item.is_active,
          email: item.email,
          fax: item.fax,
          type: this.entitySelectForm.controls.entityType.value,
        };
      }
      return item;
    });
    this.entitySelectForm.controls.entities.setValue(entities);
    this.entitySelectForm.controls.entities.updateValueAndValidity();
  }

  formatNewEntityFn(entity: any) {
    return entity;
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save() {
    this.dialogRef.close(this.entitySelectForm.controls.entities.value);
  }

  getTitle(): string {
    return 'ENTITY.SELECT_ENTITIES';
  }
}
